import { render, staticRenderFns } from "./loanapplications.vue?vue&type=template&id=1342fa30"
import script from "./loanapplications.vue?vue&type=script&lang=js"
export * from "./loanapplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports